import React from 'react'

const NavHeader = () => <div className="text-5xl text-center text-white">वर्डल</div>

export default NavHeader
